import { render, staticRenderFns } from "./dish-photo.vue?vue&type=template&id=1405c934"
import script from "./dish-photo.vue?vue&type=script&lang=js"
export * from "./dish-photo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports